import { combineReducers } from 'redux';
import reducers from 'reducers';
import { store } from './store';

const rootReducer = combineReducers({ ...reducers });

export type RootState = ReturnType<typeof store.getState>;

export default rootReducer;
